import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './types';

export interface CoachesBookingState {
  activeModal: ModalType | null;
}

const initialState: CoachesBookingState = {
  activeModal: null,
};

const coachesBookingSlice = createSlice({
  name: 'coachesBooking',
  initialState,
  reducers: {
    changeActiveModal: (state, action: PayloadAction<ModalType | null>) => {
      state.activeModal = action.payload;
      if (action.payload === null) {
        state.activeModal = null;
      }
    },
  }
});

export const selectCoachesBookingActiveModal = (state: RootState) => state.coachesBooking.activeModal;

export const { changeActiveModal: changeCoachesBookingActiveModal } = coachesBookingSlice.actions;
export { coachesBookingSlice };
